import React from 'react'
import { T } from '@transifex/react'

import { pathJoin } from 'src/reducers/routing/utils'

import { createWarehouseRouteMap } from './detailed-view'

export const createRoutesMapWarehouseManagementRouter = (prefix: string) => ({
  ':warehouseId': (warehouseId: string) =>
    pathJoin(prefix)(warehouseId).chainMapAuto(createWarehouseRouteMap, {
      title: <T _str="Warehouse Details" />,
      breadCrumbTitle: <T _str="Details" />,
    }),
})
